var objRetourInvalide = {"statusCode": 400, "dataApi": [] }

export async function  apiSessAjout(utilisateurBearer, sessionsNumber) { 
    var datasToPost= { // on créé ici comme pas d'info a donner tout de suite....
        "Etat_LHEO_Valide": 0
    }
    if (utilisateurBearer == "" || sessionsNumber == "") return objRetourInvalide;

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${utilisateurBearer}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(datasToPost)
    };

    var urlApi = global.config.apiSessionBase.url + "/" + sessionsNumber;
    if(global.config.modeDebugApi == 1) console.log(`appel POST ${urlApi} dans apiSessAjout`);

    var objRetour = {statusCode : '', dataApi : ''};
    try {
        const response = await fetch(urlApi, requestOptions);
        objRetour.statusCode = response.status; //===  400 si bad, 401 unauthorized
        if (response.status != 200 && response.status != 400) return objRetour;  // 400 : un message personnalisé est retourné dans ce cas, ex : "La fiche certif info est déjà associée"
    
        objRetour.dataApi = await response.json();
        return objRetour;
    } catch (error_1) {
        console.log('error apiSessAjout', error_1);
        return objRetour;
    }
}

export async function apiSessModif(utilisateurBearer, datasToPost, sessionsNumber) {
    if (utilisateurBearer == "") return objRetourInvalide;

    const requestOptions = {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${utilisateurBearer}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(datasToPost)
    };

    var urlApi = global.config.apiSessionBase.url + "/" + sessionsNumber;
    if(global.config.modeDebugApi == 1) console.log(`appel ${urlApi}`);

    var objRetour = {statusCode : '', dataApi : ''};
    try {
        const response = await fetch(urlApi, requestOptions);
        objRetour.statusCode = response.status; //===  400 si bad, 401 unauthorized
        if (response.status != 400) return objRetour;  // 400 : un message personnalisé est retourné dans ce cas, ex : "La fiche certif info est déjà associée"

        objRetour.dataApi = await response.json();
        return objRetour;
    } catch (error_1) {
        console.log('error apiSessModif', error_1);
        return objRetour;
    }
}

export async function apiSessAppelGetInfosDiv(utilisateurBearer, routeSuppl="") {
    if (utilisateurBearer == "") return objRetourInvalide;

    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${utilisateurBearer}`,
            'Content-Type': 'application/json'
        },
    };

    var urlApi = global.config.apiSessionBase.url + routeSuppl;
    if(global.config.modeDebugApi == 1) console.log(`appel ${urlApi}`);

    var objRetour = {statusCode : '', dataApi : ''};
    try {
        const response = await fetch(urlApi, requestOptions);
        objRetour.statusCode = response.status; //===  400 si bad, 401 unauthorized
        if (response.status != 200) return objRetour;

        objRetour.dataApi = await response.json();
        return objRetour;
    } catch (error_1) {
        console.log('error apiSessAppelGetInfosDiv', error_1);
        return objRetour;
    }
}


export async function apiSessSuppr(utilisateurBearer, sessionsNumber) {
    if (utilisateurBearer == "" || sessionsNumber == "") return objRetourInvalide;
    var objRetour = {statusCode : '', dataApi : ''};

    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${utilisateurBearer}`,
            'Content-Type': 'application/json'
        },
    };

    var urlApi = global.config.apiSessionBase.url  + "/" +  sessionsNumber;
    if(global.config.modeDebugApi == 1) console.log('appel ' + urlApi);

    try {
        const response = await fetch(urlApi, requestOptions);
        objRetour.statusCode = response.status; //===  400 si bad, 401 unauthorized, 204 NoContent si succès de la suppresion
        return objRetour;
    } catch (error_1) {
        console.log('error apiSessSuppr', error_1);
        return objRetour;
    }
}

//method= PUT ou DELETE, permet également de définir un principale (POST dans ce cas)
//codeTypeContact n'est utile qu'en cas d'association
export async function apiSessAssocDissoContact(utilisateurBearer, sessionNumber, codeContact, method='PUT', routeSuppl="", codeTypeContact) {
    if (utilisateurBearer == "" || codeContact == "" || method == "") return objRetourInvalide;

    const requestOptions = {
        method: method,
        headers: {
            'Authorization': `Bearer ${utilisateurBearer}`,
            'Content-Type': 'application/json'
        },
    };

    var urlApi = global.config.apiSessionBase.url  + "/" + sessionNumber  + "/contacts/" + codeContact + routeSuppl;
    if(codeTypeContact != undefined)  urlApi += "/" + codeTypeContact;
    if(global.config.modeDebugApi == 1) console.log('appel ' + urlApi + ' avec methode ' + method);

    var objRetour = {statusCode : '', dataApi : ''};
    try {
        const response = await fetch(urlApi, requestOptions);
        objRetour.statusCode = response.status; //===  400 si bad, 401 unauthorized
        if (response.status != 200 && response.status != 400) return objRetour;  // 400 : un message personnalisé est retourné dans ce cas, ex : "La fiche certif info est déjà associée"

        objRetour.dataApi = await response.json();
        return objRetour;
    } catch (error_1) {
        console.log('error apiSessAssocDissoContact', error_1);
        return objRetour;
    }
}